export const getFormattedTime = (time: string): string => {
  const now = new Date(time)
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')

  return `${hours}:${minutes}`
}
